import React from 'react';
import { useField } from 'formik';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

const AppTextField = (props) => {
  const { selectOptions, ...otherProps } = props;
  const [field, meta] = useField(props);
  const errorText = meta.error && meta.touched ? meta.error : '';

  if (selectOptions) {
    return (
      <FormControl fullWidth variant='outlined' error={!!errorText}>
        <InputLabel id={`${field.name}-label`}>{props.label}</InputLabel>
        <Select
          labelId={`${field.name}-label`}
          id={`${field.name}-select`}
          label={props.label}
          name={field.name}
          value={field.value}
          onChange={field.onChange}
        >
          {selectOptions.map((option) => (
            <MenuItem key={option.id} value={option.id}>
              {option.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }

  return (
    <TextField
      {...otherProps}
      {...field}
      helperText={errorText}
      error={!!errorText}
    />
  );
};

export default AppTextField;
// AppTextField.propTypes = {
//   props: PropTypes.object.isRequired,
// }
